'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openInNewTab = exports.reloadPage = exports.setWindowLocation = undefined;

var _form = require('./form');

Object.keys(_form).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _form[key];
        }
    });
});

var _fetch = require('./fetch');

Object.keys(_fetch).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _fetch[key];
        }
    });
});

var _upload = require('./upload');

Object.keys(_upload).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _upload[key];
        }
    });
});

var _imageUpload = require('./image-upload');

Object.keys(_imageUpload).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _imageUpload[key];
        }
    });
});

var _errors = require('./errors');

Object.keys(_errors).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _errors[key];
        }
    });
});

var _featureDetection = require('../feature-detection');

/**
 * Set window location
 * @param {string} url The url path of the page to be navigated
 */
var setWindowLocation = exports.setWindowLocation = function setWindowLocation(url) {
    if (_featureDetection.HAS_WINDOW) {
        window.location.href = url;
    }
};

/**
 * Reload the page
 *
 * @param forcedReload - if false or unspecified, browser may use its cache. If true, page will always
 * be reloaded from the server.
 */
var reloadPage = exports.reloadPage = function reloadPage(forcedReload) {
    if (_featureDetection.HAS_WINDOW) {
        window.location.reload(forcedReload);
    }
};

/**
 * Open url in a new tab
 *
 * @param url - the url path of the page to be navigated
 */
var openInNewTab = exports.openInNewTab = function openInNewTab(url) {
    if (_featureDetection.HAS_WINDOW) {
        window.open(url, '_blank');
    }
};